export { default as AdPrice } from './AdPrice';



// WEBPACK FOOTER //
// ./src/components/AdCard/AdSummary/AdPrice/index.ts